import { CloseCircleOutlined } from '@ant-design/icons';
import { Button, message } from 'antd';
import { useContext, useMemo, useState } from 'react';
import { deleteRejectedBacklink } from 'services/api/domains';
import DomainContext from 'services/domainContext';
import ProfileContext from 'services/profileContext';
import styles from 'styles/components/onboarding.module.scss';

const RejectedValidation = () => {
  const { domains, updateDomains } = useContext(DomainContext);
  const { updateProfile } = useContext(ProfileContext);
  const [removeLoading, setRemoveLoading] = useState(false);

  const rejectedDomain = useMemo(
    () =>
      domains?.find(
        (d) => d.status === 'REJECTED' || d.status === 'BANNED'
      ) || domains?.[0],
    [domains]
  );

  const removeDomain = () => {
    if (!rejectedDomain?.name) return;
    setRemoveLoading(true);
    deleteRejectedBacklink({ name: rejectedDomain.name })
      .then(() => Promise.all([updateDomains(), updateProfile({ silent: true })]))
      .catch((e) => {
        console.error(e);
        message.error('Error while deleting domain, please try again');
      })
      .finally(() => {
        setRemoveLoading(false);
      });
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <CloseCircleOutlined
          style={{ fontSize: 72, color: '#ff7875', marginBottom: 12 }}
        />
      </div>
      <h1 className={styles.title}>Your site was not approved</h1>
      <div style={{ textAlign: 'center' }}>
        You can remove this domain and apply with a different site. Upgrading
        to Pro will not unlock access.
      </div>
      {rejectedDomain?.name && (
        <div style={{ textAlign: 'center', marginTop: 26 }}>
          <Button onClick={removeDomain} loading={removeLoading} size="large">
            Remove {rejectedDomain.name}
          </Button>
        </div>
      )}
    </div>
  );
};

export default RejectedValidation;
